import * as React from "react";
import IconChevronUp from "./icon/iconchevronup";
import IconChevronDown from "./icon/iconchevrondown";

interface ToggleScheduleProps {
    toggleSchedule: () => void;
    showSchedule: boolean;
    showLabel: string;
    hideLabel: string;
}
const ToggleSchedule = (
    { showSchedule, toggleSchedule, showLabel, hideLabel }: ToggleScheduleProps,
) => {
    if (showSchedule) {
        return (
            <span
                className="schedule-link"
                role="button"
                onClick={toggleSchedule}
            >
                {hideLabel} <IconChevronUp />
            </span>
        );
    } else {
        return (
            <span
                className="schedule-link"
                role="button"
                onClick={toggleSchedule}
            >
                {showLabel} <IconChevronDown />
            </span>
        );
    }
};

export default ToggleSchedule;
